import { arrayBufferDownload, arrayBufferDownloadExcel, downloadCSV } from "../../../../utils/download";
import { decorateEmptyGridValues, setColumnDefaultExtraProps } from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_RENTERS_REVENUEAGREEMENTS_LIST, 
  TOAST, 
  FETCH_RENTERS_REVENUEAGREEMENTS_INIT,
  FETCH_RENTERS_REVENUEAGREEMENTS_DETAIL,
  EXPORT_RENTERS_REVENUEAGREEMENTS,
  CREATE_RENTERS_REVENUEAGREEMENTS,
  EDIT_RENTERS_REVENUEAGREEMENTS,
  INIT_CREATE_RENTERS_REVENUEAGREEMENTS_SCREEN,
  RENTERS_REVENUEAGREEMENTSDD,
  RENTERS_REVENUEAGREEMENTSDELETE,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  RENTERS_REVENUEAGREEMENTSEXISTINGDATA
} from "../../../types/Renters/RevenueAgreements.type";



  const formFieldValueMap = {
    id:null,
    description:"",
    modBy:"",
    modTime:"",
    status:1,
    title:"",
    userId:""
  };
  
  const INITIAL_STATE = {
    RentersRevenueAgreementsListview: [],
    RentersRevenueAgreementsDD:[],
    isRentersRevenueAgreementsDDSuccess: false,
    isRentersRevenueAgreementsDDError: false,
    RentersRevenueAgreementsExistingData:[],
    isRentersRevenueAgreementsExistingDataSuccess: false,
    isRentersRevenueAgreementsExistingDataError: false,
    isLoading: false,
    error: null,
    formFieldValueMap,
    isRentersRevenueAgreementsCreateSuccess: false,
    isRentersRevenueAgreementsCreateError: false,
    isRentersRevenueAgreementsDetailSuccess: false,
    isRentersRevenueAgreementsDetailError: false,
    isRentersRevenueAgreementsEditSuccess: false,
    isRentersRevenueAgreementsEditError: false,
    isRentersRevenueAgreementsExportSuccess: false,
    isRentersRevenueAgreementsExportError: false,
    isUploadImageSuccess: false,
    isUploadImageError: false,
    imageUploadResponse:null,
    isRentersRevenueAgreementsDeleteSuccess: false,
    isRentersRevenueAgreementsDeleteError: false,
  };
  
  const tranformToGridView = (data) => {
    const rows = data.map((item) => {
      const {
        crtBy,
crtTime,
description,
id,
modBy,
modTime,
status,
title
      } = item;
  
      const transformedValues = {
        crtBy,
crtTime,
description,
id,
modBy,
modTime,
status,
title
      };
      const decoratedValues = {};
      Object.keys(transformedValues).forEach((key) => {
        decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
      });
      return decoratedValues;
    });
  
    const columns = [
      {
        colLabel: "ID",
        dataKey: "id",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Rental Id",
        dataKey: "rentalId",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Location",
        dataKey: "location",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Vehicle Category",
        dataKey: "vehicleCategory",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      
      {
        colLabel: "Renter Email ID",
        dataKey: "renterEmailID",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Vehicle Plate Number",
        dataKey: "vehiclePlateNumber",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Vehicle Plate Number",
        dataKey: "vehiclePlateNumber",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Status",
        dataKey: "status",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Crt By",
        dataKey: "crtBy",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Crt Time",
        dataKey: "crtTime",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Mod By",
        dataKey: "modBy",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Edit Time",
        dataKey: "modTime",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      
    ];
  
    return {
      datas: { columns, rows },
    };
  };

  export const RentersRevenueAgreementsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_RENTERS_REVENUEAGREEMENTS_INIT:
        return { ...INITIAL_STATE, isLoadingPage: true };
      case FETCH_RENTERS_REVENUEAGREEMENTS_DETAIL.START:
        case RENTERS_REVENUEAGREEMENTSEXISTINGDATA.START:
      case EXPORT_RENTERS_REVENUEAGREEMENTS.START:
        case UPLOAD_IMAGE.START:
      case FETCH_RENTERS_REVENUEAGREEMENTS_LIST.START:
      case CREATE_RENTERS_REVENUEAGREEMENTS.START:
        case RENTERS_REVENUEAGREEMENTSDELETE.START:
        case EDIT_RENTERS_REVENUEAGREEMENTS.START:
          case RENTERS_REVENUEAGREEMENTSDD.START:
        return { ...state, isLoading: true };
  
      case FETCH_RENTERS_REVENUEAGREEMENTS_LIST.SUCCESS: {
        const { page, data } = action.payload;
       
        let resetState = {
          RentersRevenueAgreementsListview: [],
          paginationInfo:null,
          error: null,
          isLoading: false,
          isLoadingPage: false,
          isPageLevelError: false,
          isRentersRevenueAgreementsCreateSuccess: false,
          isRentersRevenueAgreementsCreateError: false,
        };
        if (!data) {
          return resetState;
        }
        const { number, size, totalElements, totalPages } = page;
        const { datas } = tranformToGridView(data);
        return {
          ...resetState,
          RentersRevenueAgreementsListview: datas,
          paginationInfo: {
            pageSize: size,
            totalRecords: totalElements,
            totalPages: totalPages,
            pageNumber: number,
          },
        };
      }
      case FETCH_RENTERS_REVENUEAGREEMENTS_LIST.ERROR: {
        const { error } = action.payload;
  
        return {
          ...state,
          RentersRevenueAgreementsListview: [],
          isLoading: false,
          isLoadingPage: false,
          error,
          isPageLevelError: true,
          isRentersRevenueAgreementsDeletionSuccess: false,
          isRentersRevenueAgreementsDeletionError: false,
          shouldOpenDeleteConfirmationPopup: false,
        };
      }

    case FETCH_RENTERS_REVENUEAGREEMENTS_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
              temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isRentersRevenueAgreementsDetailSuccess: true,
      };
    }
    case FETCH_RENTERS_REVENUEAGREEMENTS_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isRentersRevenueAgreementsDetailSuccess: false,
        isRentersRevenueAgreementsDetailError: true,
      };
    }

    //DD
    case RENTERS_REVENUEAGREEMENTSDD.SUCCESS: {
      const temp = action.payload;
 
      return {
        ...state,
        isLoading: false,
        RentersRevenueAgreementsDD:temp,
        isRentersRevenueAgreementsDDSuccess: true,
        isRentersRevenueAgreementsDDError: false,
      };
    }
    case RENTERS_REVENUEAGREEMENTSDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isRentersRevenueAgreementsDDSuccess: false,
        isRentersRevenueAgreementsDDError: true,
      };
    }
    //END DD

 //Existing Data
 case RENTERS_REVENUEAGREEMENTSEXISTINGDATA.SUCCESS: {
  const temp = action.payload;

  return {
    ...state,
    isLoading: false,
    RentersRevenueAgreementsExistingData:temp,
    isRentersRevenueAgreementsExistingDataSuccess: true,
    isRentersRevenueAgreementsExistingDataError: false,
  };
}
case RENTERS_REVENUEAGREEMENTSEXISTINGDATA.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    error,
    isRentersRevenueAgreementsExistingDataSuccess: false,
    isRentersRevenueAgreementsExistingDataError: true,
  };
}
//END Existing Data
    
//DELETE

case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY: {
  const shouldOpenDeleteConfirmationPopup = action.payload;
  return {
    ...state,
    shouldOpenDeleteConfirmationPopup,
    isRentersRevenueAgreementsDeleteSuccess: false,
    isRentersRevenueAgreementsDeleteError: false,
  };
}
case RENTERS_REVENUEAGREEMENTSDELETE.SUCCESS: {
  const temp = action.payload;

  return {
    ...state,
    isLoading: false,
    isRentersRevenueAgreementsDeleteSuccess: true,
    isRentersRevenueAgreementsDeleteError: false,
    shouldOpenDeleteConfirmationPopup: false,
  };
}
case RENTERS_REVENUEAGREEMENTSDELETE.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    error,
    isRentersRevenueAgreementsDeleteSuccess: false,
    isRentersRevenueAgreementsDeleteError: true,
    shouldOpenDeleteConfirmationPopup: false,
  };
}
//END DD   
    
// UPLOAD_IMAGE Start
case UPLOAD_IMAGE.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isUploadImageSuccess: false,
    isUploadImageError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case UPLOAD_IMAGE.SUCCESS: {
  const  {data}  = action.payload;
   return {
    ...state,
    imageUploadResponse:data,
    isUploadImageSuccess: true,
    isUploadImageError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// UPLOAD_IMAGE End

// Export Start
case EXPORT_RENTERS_REVENUEAGREEMENTS.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isRentersRevenueAgreementsExportSuccess: false,
    isRentersRevenueAgreementsExportError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case EXPORT_RENTERS_REVENUEAGREEMENTS.SUCCESS: {
  const  data  = action.payload;
  arrayBufferDownloadExcel(data,"revenue-agreements.xls");
   return {
    ...state,
    isRentersRevenueAgreementsExportSuccess: true,
    isRentersRevenueAgreementsExportError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// Export End

// EDIT
case EDIT_RENTERS_REVENUEAGREEMENTS.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isRentersRevenueAgreementsEditSuccess: false,
    isRentersRevenueAgreementsEditError: true,
  };
}

case EDIT_RENTERS_REVENUEAGREEMENTS.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isRentersRevenueAgreementsEditSuccess: true,
    isRentersRevenueAgreementsEditError: false,
  };
}

// EDIT END

// Create
case INIT_CREATE_RENTERS_REVENUEAGREEMENTS_SCREEN: {
  return { ...INITIAL_STATE };
}

case CREATE_RENTERS_REVENUEAGREEMENTS.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isRentersRevenueAgreementsCreateSuccess: false,
    isRentersRevenueAgreementsCreateError: true,
  };
}
case CREATE_RENTERS_REVENUEAGREEMENTS.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isRentersRevenueAgreementsCreateSuccess: true,
    isRentersRevenueAgreementsCreateError: false,
  };
}

//End
  

      case TOAST.RESET: {
        return {
          ...state,
          isRentersRevenueAgreementsCreateSuccess: false,
          isRentersRevenueAgreementsCreateError: false,
          isRentersRevenueAgreementsEditError: false,
          isRentersRevenueAgreementsEditSuccess: false,
          isRentersRevenueAgreementsDetailError: false
        };
      }
      default:
        return state;
    }
  };
  